var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxRomanian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-romanian") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RMG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-Language-selection-\\u2013-RMG",
    transform: "translate(-16.000000, -574.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-romanian",
    transform: "translate(16.000000, 574.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9797793,0.74634375 C14.6929031,0.264046875 13.301115,0 11.8481245,0 C10.3951339,0 9.00329939,0.264046875 7.71646962,0.74634375 L6.6835443,11.9999531 L7.71646962,23.2535625 C9.00325299,23.736 10.3950875,24 11.8481245,24 C13.3010686,24 14.6929495,23.736 15.9797793,23.2535625 L17.0126582,12 L15.9797793,0.74634375 Z",
    id: "Path",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12.1518519 C24,6.99834959 20.7132803,2.60488 16.1012658,0.911392405 L16.1012658,23.3924051 C20.7132803,21.6987302 24,17.3054479 24,12.1518519 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.1518051 C0,17.3054693 3.28673938,21.69877 7.89873418,23.3924051 L7.89873418,0.911392405 C3.28673938,2.60488705 0,6.99823448 0,12.1518051 Z",
    id: "Path",
    fill: "#0052B4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxRomanian);
export default __webpack_public_path__ + "static/media/px-romanian.639335cf9caf597a19a6ce7895d9666e.svg";
export { ForwardRef as ReactComponent };